var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('iframe',{attrs:{"id":"menu-iframe","width":_vm.iframeWidth,"height":_vm.iframeHeight,"src":_vm.menuIframeUrl,"frameborder":"0","scrolling":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }